import { Avatar, Link, Typography } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { LeftArrow } from 'Images';

interface ITitle {
  count: number;
  displayCount: number;
}
export const Title = ({ count, displayCount }: ITitle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userRights;
  const isDesktop = useIsDesktop();
  return (
    <Typography
      variant='body6'
      mb={isDesktop ? 3 : 0}
      sx={{ maxWidth: isDesktop ? undefined : '318px' }}
    >
      {`${dictionary.subTitle.found} `}
      <strong>{count}</strong>
      {` ${dictionary.subTitle.rights} `}
      {displayCount}
      {` ${dictionary.subTitle.locationAt} `}
      <Link
        underline='none'
        display='inline-flex'
        alignItems='flex-end'
        href='/compass-rights'
      >
        <Typography variant='body5'>{dictionary.compassRights}</Typography>
        <Avatar sx={{ width: '20px', height: '24px' }} alt='' src={LeftArrow} />
      </Link>
    </Typography>
  );
};
